import "./FileInput.scss";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useFileInputLogic from "./FileInputLogic";
import { truncateString } from "../../../helpers";

const FileInput = ({
  name = "",
  onChange = () => {},
  errorMessage = undefined,
  placeHolder = null,
  isDisabled,
  coverStyle = {},
  floatError = true,
  truncateTextSize = 40,
  showFileName = true,
  ...rest
}) => {
  const inputRef = useRef();
  const fileInputLogic = useFileInputLogic({ inputRef, onChange });

  return (
    <div
      className={"file-input__container " + (isDisabled ? "disabled" : "")}
      style={{ ...coverStyle }}
    >
      <label
        // onClick={() => fileInputLogic.handleClick()}
        className="file-input"
        htmlFor={name}
      >
        <input
          ref={inputRef}
          type="file"
          id={name}
          name={name}
          // accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt"
          accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
          onChange={fileInputLogic.handleChange}
          disabled={isDisabled}
          {...rest}
        />
        {fileInputLogic?.fileName && showFileName ? (
          <p>{truncateString(fileInputLogic.fileName, truncateTextSize)}</p>
        ) : (
          <>
            {placeHolder ? (
              <p className="purple--text">{placeHolder}</p>
            ) : (
              <p className="file-input__text">
                Drag and drop document here or{" "}
                <span className="purple--text">Browse</span>
              </p>
            )}
          </>
        )}
      </label>

      {floatError || errorMessage !== undefined ? (
        <p
          className={`error-message text-danger ${
            errorMessage !== undefined ? "show" : ""
          }`}
          data-testid="error-message"
        >
          <FontAwesomeIcon
            icon={["fas", "exclamation-circle"]}
            className="mr-2"
            style={{ fontSize: "13px" }}
          />
          {errorMessage !== undefined && <span>{errorMessage?.message}</span>}
        </p>
      ) : null}
    </div>
  );
};

export default FileInput;
